import React, { Component } from 'react'

class AddManual extends Component {
  constructor (props) {
    super(props)

    this.state = {
      edit: true,
      title: '',
      is_show: false,
      file_url: '',
      pdf: ''
    }
  }

  _handleCancelClick () {
    this.setState({
      edit: false,
      title: this.state.title,
      is_show: this.state.is_show,
      file_url: this.state.file_url
    })
    this.props.cancel()
  }
  _handleSaveClick () {
    console.log('saving data...')
    const { title, is_show, pdf } = this.state
    const data = {
      title,
      is_show
    }
    if (!this.state.pdf) {
      this.props.saveData(data)
    } else {
      this.props.saveData(data, pdf)
    }
    this.setState({ edit: false })
  }

  _handleShowSwitch (e) {
    this.setState({ is_show: e.target.checked })
  }

  _handleUpdateContent (key, e) {
    this.setState({ [key]: e.target.value })
  }

  _handleAddPDF (e) {
    const pdf = e.target.files[0]
    console.log(pdf)
    if (pdf) {
      if (pdf.type === 'application/pdf' && pdf.name.indexOf('pdf') > 0) {
        this.setState({ pdf, file_url: URL.createObjectURL(pdf) })
        console.log('sending pdf file')
      } else {
        console.log('wrong file type')
        // this.setState({ image_error: '画像ファイル外を選択しました。\n確認の上でもう一度画像ファイルを選択してください。' })
      }
    }
  }

  _renderManualTitle () {
    return <input type="text" value={this.state.title} onChange={this._handleUpdateContent.bind(this, 'title')}/>
  }
  _renderManualShow () {
    return [
      <input type="checkbox" id="newItem_showSwitch" className="switch-input" key="checkbox" onChange={this._handleShowSwitch.bind(this)} checked={this.state.is_show}/>,
      <label htmlFor="newItem_showSwitch" className="switch-label" key="label">
        <span className="toggle--on">表示</span>
        <span className="toggle--off">非表示</span>
      </label>
    ]
  }
  _renderManualLink () {
    return (
      <label htmlFor="add_csv" className="btn primary flex align-center">
        <svg viewBox="0 0 24 24" className="icon_upload">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="17 8 12 3 7 8"></polyline>
          <line x1="12" y1="3" x2="12" y2="15"></line>
        </svg>
        <span>PDFファイル</span>
        <input
          type="file"
          id="add_csv"
          onChange={this._handleAddPDF.bind(this)}
        />
      </label>
    )
  }

  _renderBtns () {
    return [
      <button key="cancel" className="btn reverse_red" onClick={this._handleCancelClick.bind(this)}>キャンセル</button>,
      <button key="save" className="btn reverse_primary" onClick={this._handleSaveClick.bind(this)}>保存</button>
    ]
  }

  render () {
    return (
      <article className={ !this.state.is_show ? 'manual new_manual hide' : 'manual new_manual' }>
        <div className="manual_inner admin_inner flex column">
          <div className="contents flex top_label justify-between">
            <div className="left flex">
              <div className="manual_label label">PDFタイトル</div>
              { this._renderManualTitle()}
            </div>
            <div className="right">
              { this._renderManualShow() }
            </div>
          </div>
          <div className="contents flex bottom_label">
            { this._renderManualLink()}
          </div>
        </div>
        <div className="btn_group flex">
          { this._renderBtns() }
        </div>
      </article>
    )
  }
}

export default AddManual



// WEBPACK FOOTER //
// ./src/components/Properties/Manuals/AddManual.js